import Icon from "@material-ui/core/Icon";
import { Button, Typography } from "@material-ui/core";
import useWindowDimensions from "../../hooks/useWindowDimension";
import { MD_BREAKPOINT } from "../../config/breakpoints";
import { getTrimmedValue, isNullUndefinedOrEmpty } from "../../config/validation";
import React, { useCallback, useState } from "react";

const Input = (props) => {
  const {
    onChangeText,
    onKeyPress,
    onButtonPress,
    value,
    required,
    number,
    email,
    className,
    placeholder,
    maxLength = null,
    showMaxLengthCounter = false,
    externalRef=null,
    textarea = false,
    file = false,
    updateFieldErrorMessageCallback = null
  } = props;
  
  /* SETTING INPUT FIELD PROPS */
  const inputFieldProps = {
    placeholder: placeholder,
  }

  if (maxLength !== null) {
    inputFieldProps.maxLength = maxLength;
    inputFieldProps.showMaxLengthCounter = showMaxLengthCounter;
  } 
  /* *********************** */


  const { width } = useWindowDimensions();
  const currValue = value ? value : '';
  const [errorMessage, setErrorMessage] = useState(null);

  const styles = {
    container: {
      position: "relative",
      backgroundColor: "white",
      borderRadius: 5,
      display: "flex",
      justifyContent: "space-between",
      flexDirection: "column",
      alignItems: "center",
    },
    input: {
      borderWidth: 0,
      backgroundColor: "transparent",
      width: "100%",
      height: "100%",
      color: props.style.textColor || "#333333",
      fontWeight: props.style.fontWeight || 600,
      opacity: 0.9,
      fontSize: width > MD_BREAKPOINT ? 16 : 13,
    },
  };

  const validateEmail = (email) => {
    const re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  };

  const onChangeTextTrimHandler = useCallback((currValue) => {
    if (onChangeText !== null && onChangeText !== undefined && !file) {
        const parsedValue = getTrimmedValue(currValue);
        onChangeText(parsedValue); 
    }
  }, [onChangeText, file])

  const handleBlur = useCallback(() => {
    let currErrorMessage = null;
    let parsedValue = !file ? getTrimmedValue(value) : value;
    if (required && isNullUndefinedOrEmpty(parsedValue)) {
      currErrorMessage = "Il campo è obbligatorio";
    } else if (number && isNaN(parsedValue) && (required || parsedValue !== "")) {
      currErrorMessage = "Il campo deve essere numerico";
    } else if (email && !validateEmail(parsedValue) && (required || parsedValue !== "")) {
      currErrorMessage = "Il campo deve essere una email valida";
    }
    setErrorMessage(currErrorMessage);
    updateFieldErrorMessageCallback && updateFieldErrorMessageCallback(currErrorMessage);
    onChangeTextTrimHandler(value);
  }, [required, value, number, email, file, onChangeTextTrimHandler]);

  const hasFooter = (required || email || number) || (maxLength !== null && maxLength !== undefined && showMaxLengthCounter && !file);

  return (
    <div
      style={{
        ...styles.container,
        ...props.style,
        backgroundColor: "transparent",
        padding: 0,
        paddingTop: 0,
        paddingBottom: 0,
        border: "none",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
          borderRadius: 5,
          ...props.style,
          width: "90%",
          height: "100%",
          paddingLeft: "5%",
          paddingRight: "5%",
        }}
      >
        {!textarea && !file && (
          <input
            {...inputFieldProps}
            ref={externalRef}
            style={styles.input}
            type="text"
            value={currValue}
            // maxLength={maxLength}
            // placeholder={props.placeholder}
            onChange={(event) => {
              onChangeText && onChangeText(event.target.value);
            }}
            onKeyPress={(event) => {
              onKeyPress && onKeyPress(event)
            }}
            onBlur={() => handleBlur()}
            onFocus={() => setErrorMessage(null)}
            className={className || null}
          />
        )}

        {textarea && !file && (
          <textarea
            {...inputFieldProps}
            ref={externalRef}
            value={currValue}
            // maxLength={maxLength}
            style={{ ...styles.input, resize: "none" }}
            // placeholder={props.placeholder}
            onChange={(event) => {
              onChangeText && onChangeText(event.target.value);
            }}
            onBlur={() => handleBlur()}
            onFocus={() => setErrorMessage(null)}
          />
        )}
        {!textarea && file && (
          <input
            {...inputFieldProps}
            style={styles.input}
            type="file"
            value={value ? value.filename : []}
            // placeholder={props.placeholder}
            onChange={(e) => {
              onChangeText && onChangeText(e);
            }}
            onBlur={() => handleBlur()}
            onFocus={() => setErrorMessage(null)}
          />
        )}
        {props.icon && (
          <Icon
            fontSize="large"
            style={{ opacity: 0.5, marginRight: props.button ? 20 : 0 }}
          >
            {props.icon}
          </Icon>
        )}
        {props.button && (
          <Button
            variant="contained"
            style={{
              height: "100%",
              width: "40%",
              textTransform: "none",
              ...props.buttonStyle,
            }}
            color="primary"
            onClick={onButtonPress}
          >
            <Typography variant="h6" style={{ color: "white" }}>
              {props.button}
            </Typography>
          </Button>
        )}
        {props.iconButton && (
          <Button
            variant="contained"
            style={{
              height: "100%",
              width: "40%",
              textTransform: "none",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
            color="primary"
            onClick={onButtonPress}
          >
            <Icon fontSize="large">{props.iconButton}</Icon>
          </Button>
        )}
      </div>

      {
        hasFooter && (
          <div style={{display: "flex", flexDirection: "row-reverse", justifyContent: "space-between", width: "100%", marginTop: 3, marginBottom: 6}}>
            {maxLength !== null && maxLength !== undefined && showMaxLengthCounter && !file && (
              <Typography
                variant="h6"
                color={"black"}
                style={{ fontSize: width > MD_BREAKPOINT ? 14 : 11 }}
              >
                {(value?.length || 0)}/{maxLength}
              </Typography>
            )}

            {(required || email || number) && (
              <div
                style={{
                  visibility:
                    errorMessage !== null && errorMessage !== ""
                      ? "visible"
                      : "hidden",
                }}
              >
                <Typography
                  variant="h6"
                  color={"error"}
                  style={{ fontSize: width > MD_BREAKPOINT ? 14 : 11 }}
                >
                  {errorMessage ? errorMessage : "Errore validazione campo"}
                </Typography>
              </div>
            )}
          </div>   
        )
      }
    </div>
  );
};

export default Input;
